import { Theme } from '../../../../../components/constants'

export default {

    errorText: {
        fontWeight: "500",
        color: Theme.ERROR_TEXT,
    },

    payerCounts: {
        display: "flex",
        margin: "16px",
        alignItems: "baseline",
        columnGap: "30px",
    },

    individualPayer: {
        display: "flex",
        alignItems: "baseline",
        columnGap: "8px",
        cursor: "pointer"
    },

    payerType: {
        fontWeight: "400",
        fontSize: "16px",
        lineHeight: " 19px",
        color: Theme.TEXT_PRIMARY_BLACK,
    },

    errorReport: {
        fontWeight: "700",
        fontSize: "16px",
        color: Theme.TEXT_PRIMARY,
        cursor: "pointer"
    },

    bacisCard: {
        minWidth: "600px",
        maxWidth: "40%"
    }
}